import React from 'react';
import { UserTable } from '../../Components/Users/UserTable';

export const UsersScreen = () => {
  return (
    <div className="user-screen">
      <UserTable />
    </div>
  );
};
